import { InternalTracker, MultiTracker, PosthogTracker } from '@last/core-ui/paprika'

const trackers = []

if (import.meta.env.VITE_POSTHOG_API_KEY) {
  trackers.push(new PosthogTracker(import.meta.env.VITE_POSTHOG_API_KEY))
}

trackers.push(new InternalTracker(import.meta.env.VITE_APP_BASE_URL))

export const tracker = new MultiTracker(trackers)
